import { PaginateQuery, PaginatorModel, UnknownError } from 'symbols';
import { TalonModel, TalonsFilterModel } from '../../symbols';

export class GetTalonList {
  static type = '[talonList] GetTalonList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<TalonsFilterModel>) {
  }
}

export class GetTalonListSuccess {
  static type = '[talonList] GetTalonListSuccess';

  constructor(public talonList: PaginatorModel<TalonModel>, public lazy: boolean) {
  }
}

export class GetTalonListError {
  static type = '[talonList] GetTalonListError';

  constructor(public error: UnknownError) {
  }
}

export class ClearScrollPositionTalonList {
  static type = '[talonList] ClearScrollPositionTalonList';
}

export class UpdateScrollPositionTalonList {
  static type = '[talonList] UpdateScrollPositionTalonList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedTalonId {
  static type = '[talonList] SetLastOpenedTalonId';

  constructor(public talonId: string) {
  }
}
